import {IFrequentParkerActivity, IFrequentParkerSettings} from "../../../data/interfaces";

﻿import * as ng from 'angular';
import * as Linq from 'linq-es5';
import {ICustomerSettingsService, ISessionService, IToastMessageService} from '../../../services';
import { IAccountActivityResource } from '../data/account-activity';
import { IFrequentParkerActivityResource } from '../data/frequent-parker-activity';
import { Dto } from '../../../data';

let ActivitiesServiceFactory: Function =
    function ($q: ng.IQService,
        Session: ISessionService,
        AccountActivity: IAccountActivityResource,
        FrequentParkerAccount: IFrequentParkerActivityResource,
        toastMessageFactory: IToastMessageService,
        CustomerSettings: ICustomerSettingsService): IActivitiesService {
        return new ActivitiesService($q, Session, AccountActivity, CustomerSettings, FrequentParkerAccount, toastMessageFactory);
    }

ActivitiesServiceFactory.$inject = ['$q', 'Session', 'AccountActivity', 'FrequentParkerActivity', 'toastMessageFactory', 'CustomerSettings'];

let Activities = {
    name: "Activities",
    factory: ActivitiesServiceFactory
};

interface IActivitiesService {
    loadAccountWithActivities(controller, criteria, frequentParkerCriteria): any;
    computeSummaryData(controller, activities, loadLatestActivity): any;
    computeFpSummaryData(controller, activities, loadLatestActivity): void;
    getAccountActivity(criteria: Dto.IAccountActivityCriteria): ng.IPromise<Array<Dto.IAccountActivity>>;
    getFrequentParkerActivity(criteria: Dto.IFrequentParkerActivityCriteria): Promise<Dto.IFrequentParkerActivity[]>;
    addFrequentParkerAdjustment(frequentParkerId: string, adjustment: Dto.IAdjustment): ng.IPromise<Array<Dto.IFrequentParkerActivity>>;
    getCurrentFppBalance(frequentParkerAccountId: string): Promise<number>;
}

export class ActivitiesService implements IActivitiesService {
    private static $inject: Array<string> = ['CustomerSettings'];
    constructor(private $q: ng.IQService,
        private Session: ISessionService,
        private AccountActivity: IAccountActivityResource,
        private CustomerSettings: ICustomerSettingsService,
        private FrequentParkerActivity: IFrequentParkerActivityResource,
        private toastMessageFactory: IToastMessageService) {

        console.log('ActivitiesService loading');



        //activate service
        this.activate();
    }

    //functions
    public activate(): void {
        console.log('ActivitiesService loaded');
    }

    // private interface

    public loadAccountWithActivities(controller, criteria: Dto.IAccountActivityCriteria,
        frequentParkerCriteria: Dto.IFrequentParkerActivityCriteria): any {
        let self = this;
        return self.Session.getSessionAsync()
            .then((session) => {
                controller.session = session;
                controller.activities = [];
                controller.fpActivities = [];
                var promises = [];
                const getFrequentParkerSettings = (): ng.IPromise<IFrequentParkerSettings> => {
                    const q = this.$q.defer();
                    this.CustomerSettings.getFrequentParkerSettings().then(response => {
                        q.resolve(response.settings)
                    });
                    return q.promise;
                };

                promises.push(getFrequentParkerSettings());
                                
                if (criteria != null && session.account) {
                    criteria.accountId = session.account.id;
                    promises.push(
                        self.AccountActivity.query({ accountId: criteria.accountId }, criteria).$promise
                            .then(successAcctActivity)
                            .catch(fail)
                            .finally(always)
                    );
                }

                if (frequentParkerCriteria != null && session.frequentParkerAccount != null) {
                    frequentParkerCriteria.frequentParkerAccountId = session.frequentParkerAccount.id;
                    promises.push(
                        self.FrequentParkerActivity.query({ frequentParkerAccountId: frequentParkerCriteria.frequentParkerAccountId }, frequentParkerCriteria).$promise
                            .then(successFpActivity)
                            .catch(fail)
                            .finally(always)
                    );
                }
                return self.$q.all(promises)
                    .then(successAllActivity)
                    .catch(fail)
                    .finally(always);

                function successAcctActivity(response) {
                    if (response.length === 0 && criteria.pageSize > 1) {
                        var loadLatestActivityCriteria = {
                            accountId: null,
                            startDate: null,
                            endDate: criteria.endDate,
                            minAmount: null,
                            maxAmount: null,
                            mediaIdentifier: null,
                            transactionType: null,
                            pageSize: 1,
                            pageNumber: 1
                        } as Dto.IAccountActivityCriteria;
                        self.loadAccountWithActivities(controller, loadLatestActivityCriteria, null);
                    } else {
                        controller.activities = response;
                        console.log('AccountActivities retrieved from API. ' + response.length + ' records.');
                        self.computeSummaryData(controller, response, criteria.pageSize == 1);
                    }
                }

                function successFpActivity(response) {
                    if (response.length === 0 && frequentParkerCriteria.pageSize > 1) {
                        var loadLatestFPActivityCriteria = {
                            frequentParkerAccountId: null,
                            startDate: null,
                            endDate: frequentParkerCriteria.endDate,
                            activityType: null,
                            pageSize: 1,
                            pageNumber: 1                          
                        } as Dto.IFrequentParkerActivityCriteria;
                        self.loadAccountWithActivities(controller, null, loadLatestFPActivityCriteria);
                    } else {
                        controller.fpActivities = response;
                        console.log('Frequent Parker Activities retrieved from API. ' + response.length + ' records.');
                        self.computeFpSummaryData(controller, response, frequentParkerCriteria.pageSize == 1);
                    }
                }

                function successAllActivity(responses) {
                    if (criteria && frequentParkerCriteria) {
                        const frequentParkerSettings = responses[0] as IFrequentParkerSettings;

                        var fpDict = Linq
                            .from(controller.fpActivities)
                            .Where((y: any) => {
                                return y.accountActivityId !== null;
                            }).ToDictionary((x: any) => {
                                return x.accountActivityId;
                            });
                        //TODO: Verify contains method line 131
                        var activitiesTemp = controller.allActivities = Linq.from(controller.activities)
                            .Select((x: any) => {
                                return {
                                    accountActivity: x,
                                    fpActivity: fpDict.has(x.id) ? fpDict.get(x.id) : null
                                };
                            }).ToArray();


                        var fpActivitiesTemp = Linq.from(controller.fpActivities)
                            .Where((x: any) => {
                                return x.accountActivityId == null;
                            })
                            .Select((x: any) => { //... look like object.accountActivity and object.fpActivity)
                                return {
                                    accountActivity: {
                                        date: x.activityDateTime,
                                        description: controller.frequentParkerActivityType[x.activityType].value
                                    },
                                    fpActivity: x
                                };
                            }).ToArray();

                        controller.allActivities = Linq.from(activitiesTemp).Union(Linq.from(fpActivitiesTemp))
                            .OrderByDescending((x) => {
                                return x.accountActivity.date // x.accountActivity != null ? x.accountActivity.date : (x.fpActivity as any).activityDateTime;
                            })
                            .ToArray();
                        
                        controller.allActivities.forEach(activity => {
                            const frequentParkerActivity = activity.fpActivity;
                            const accountActivity = activity.accountActivity;
                            if (frequentParkerActivity && frequentParkerActivity.parkHouseId)
                            {
                                const parkHouse = frequentParkerSettings.parkHouses.find(ph => ph.parkHouseId === frequentParkerActivity.parkHouseId);
                                if (!!parkHouse){
                                    frequentParkerActivity.parkHouseName = parkHouse.name;
                                    accountActivity.parkHouseName = parkHouse.name;
                                }
                                else
                                    console.log(`no parkhouse found with id ${frequentParkerActivity.parkHouseId}`)
                            }
                        });
                        console.log('AllActivities retrieved from API and joined. ' + controller.allActivities.length + ' records.');
                    }
                }

                function fail(e) {
                    console.log(e);
                }

                function always() {
                }
            });
    }

    public computeSummaryData(controller, activities, loadLatestActivity): any {
        // TODO: Replace untyped controoler with types controller (say an interface IActivityUserController)
        controller.totalCredits = 0;
        controller.totalDebits = 0;
        controller.totalParkingTrips = 0;
        controller.totalReplenishments = 0;
        controller.totalAdjustments = 0;
        controller.startingBalance = 0;
        controller.endingBalance = 0;
        controller.amufBalance = 0;
        ng.forEach(activities, (value) => {
            controller.totalCredits += value.credit;
            controller.totalDebits += value.debit;
            controller.totalParkingTrips += (value.transactionType === 6 && ((value.description.indexOf("Adjustment") === -1) && (value.description.indexOf("FP Manual") === -1))) ? 1 : 0;
            controller.totalReplenishments += (value.transactionType === 1 && value.description === "Replenishment") ? 1 : 0;
            controller.totalAdjustments += (value.transactionType === 2) ? 1 : 0;
        });
        activities.sort((a, b) => {
            //TODO: Verify Date()
            // Convert strings to dates, then subtract them to get a value that is either negative, positive, or zero.
            return (new Date(b.date) as any) - (new Date(a.date) as any);
        });
        if (activities.length > 0) {
            if (loadLatestActivity) {
                controller.startingBalance = activities[activities.length - 1].endBalance;
                controller.totalCredits = 0;
                controller.totalDebits = 0;
                controller.totalParkingTrips = 0;
                controller.totalReplenishments = 0;
                controller.totalAdjustments = 0;
            } else {
                controller.startingBalance = activities[activities.length - 1].beginBalance;

            }
            controller.endingBalance = activities[0].endBalance;
            controller.amufBalance = activities[0].endForfeitureBalance;
        }
    }

    public computeFpSummaryData(controller, activities, loadLatestActivity): void {
        controller.fpSummary = {
            totalRedeemed: 0, // total points redeemed in period
            totalAccrued: 0, //  total points accrued in period
            startingBalance: 0, // starting point balance in period
            endingBalance: 0 // ending point balance in period
        };
        controller.fpSummary.totalRedeemed = Linq
            .from(activities)
            .Where((x: any) => {
                return x.points < 0;
            })
            .Sum((x: any) => {
                return -x.points; // negate points for positive value points redeemed
            });
        controller.fpSummary.totalAccrued = Linq
            .from(activities)
            .Where((x: any) => {
                return x.points > 0;
            })
            .Sum((x: any) => {
                return x.points;
            });
        activities.sort((a: Dto.IFrequentParkerActivity, b: Dto.IFrequentParkerActivity) => {
            // Convert strings to dates, then subtract them to get a value that is either negative, positive, or zero.
            return (new Date(b.activityDateTime) as any) - (new Date(a.activityDateTime) as any);
        });
        if (activities.length > 0) {
            if (loadLatestActivity) {
                controller.fpSummary.startingBalance = activities[activities.length - 1].endPointBalance;
                controller.fpSummary.totalRedeemed = 0;
                controller.fpSummary.totalAccrued = 0;
            } else {
                controller.fpSummary.startingBalance = activities[activities.length - 1].beginPointBalance;
            }
            controller.fpSummary.endingBalance = activities[0].endPointBalance;
        }
    }

    public getAccountActivity(criteria: Dto.IAccountActivityCriteria): ng.IPromise<Array<Dto.IAccountActivity>> {
        let localCriteria = criteria || {} as Dto.IAccountActivityCriteria;
        return this.AccountActivity.search(localCriteria).$promise
            .then((response) => {
                return this.$q.resolve(response);
            })
            .catch((e) => {

                return this.$q.resolve([]);
            });
    }

    public getFrequentParkerActivity(criteria: Dto.IFrequentParkerActivityCriteria): Promise<Dto.IFrequentParkerActivity[]> {
        let localCriteria = criteria || {} as Dto.IFrequentParkerActivityCriteria;
        return new Promise<Dto.IFrequentParkerActivity[]>((resolve, reject) => {
            this.FrequentParkerActivity.search(localCriteria).$promise
                .then((frequentParkerActivityResponse) => {
                    this.CustomerSettings.getFrequentParkerSettings()
                        .then(frequentParkerSettingsResponse => {
                            frequentParkerActivityResponse.forEach(fpa => {
                                if (!!fpa.parkHouseId) {    
                                    const parkHouse =
                                        frequentParkerSettingsResponse.settings.parkHouses.find(
                                            ph => ph.parkHouseId === fpa.parkHouseId);
                                    if (!!parkHouse)
                                        fpa.parkHouseName = parkHouse.name;
                                }
                            });

                            console.log(frequentParkerActivityResponse);
                            resolve(frequentParkerActivityResponse);
                        });


                })
                .catch((e) => {
                    console.error(e);
                    resolve([]);
                });
            
        });
    }

    public addFrequentParkerAdjustment(frequentParkerId: string, adjustment: Dto.IAdjustment): ng.IPromise<Array<Dto.IFrequentParkerActivity>> {
        if (adjustment && frequentParkerId) {
            let amount = (adjustment.creditAmount)
                ? Math.abs(adjustment.creditAmount)
                : -1 * Math.abs(adjustment.debitAmount);

            return this.FrequentParkerActivity.save({
                    frequentParkerAccountId: frequentParkerId,
                    activityType: 3,
                    points: amount
                } as Dto.IFrequentParkerActivity).$promise
                .then((response) => {
                    this.toastMessageFactory.showSuccessMessage();
                    return this.$q.resolve(response);
                })
                .catch((e) => {
                    this.toastMessageFactory.showServerError();
                    return this.$q.reject(e);
                });
        }
    }

    public getCurrentFppBalance(frequentParkerAccountId: string): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            if (!frequentParkerAccountId || frequentParkerAccountId.isEmptyGuid())
                return resolve(0);

            let criteria = {
                pageNumber: 1,
                pageSize: 1,
                sortBy: "activityDateTime",
                sortDirection: "DESC",
                frequentParkerAccountId: frequentParkerAccountId

            } as Dto.IFrequentParkerActivityCriteria;

            this.getFrequentParkerActivity(criteria).then((fpActivity) => {
                if (fpActivity && fpActivity.length > 0){
                    return resolve(fpActivity[0].endPointBalance);
                }
                resolve(0);
            });
        });
    }
}

export { Activities, IActivitiesService };
export default Activities;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/dashboard/services/activities-service.ts